const AdminPanel = () => import(/* webpackChunkName: "generalPanelAdminPanel" */ '../adminPanel/AdminPanel');
const AdminPanelIndex = () => import(/* webpackChunkName: "adminPanel" */ '../adminPanel');
const AlarmsAndWarnings = () => import(/* webpackChunkName: "generalPanelAlarmsAndWarnings" */ '../alarmsAndWarnings');
const AnalysisProcessing = () => import(/* webpackChunkName: "generalPanelAnalysisProcessing" */ '../analysisProcessing');
const DataHistoryIndexRouteWrapper = () => import(/* webpackChunkName: "dataHistory" */ '@/app/generalPanel/reports/dataHistory/indexRouteWrapper');
const GeneralPanel = () => import(/* webpackChunkName: "generalPanel" */ '../GeneralPanel');
const InstallationEditing = () => import(/* webpackChunkName: "generalPanelInstallation" */ '../adminPanel/installation/editing');
const Dashboard = () => import(/* webpackChunkName: "generalPanelDashboard" */ '../dashboard');
const NetworkStatus = () => import(/* webpackChunkName: "generalPanelNetworkStatus" */ '../networkStatus');
const NetworkManagement = () => import(/* webpackChunkName: "generalPanelNetworkManagement" */ '../networkStatus/networkManagement/');
const NetworkEditing = () => import(/* webpackChunkName: "generalPanelNetworkManagement" */ '../networkStatus/networkManagement/editing');
const InstallationNetworks = () => import(/* webpackChunkName: "generalPanelNetworkManagementInstallation" */ '../networkStatus/networkManagement/installation');
const NewDataHistoryReport = () => import(/* webpackChunkName: "dataHistory" */ '@/app/generalPanel/reports/dataHistory/newReport');
const NewOscillographyReport = () => import(/* webpackChunkName: "oscillography" */ '@/app/generalPanel/reports/oscillography/newReport');
const OscillographyIndexRouteWrapper = () => import(/* webpackChunkName: "oscillography" */ '@/app/generalPanel/reports/oscillography/indexRouteWrapper');
const NewOperationsHistoryReport = () => import(/* webpackChunkName: "operationsHistory" */ '@/app/generalPanel/reports/operationsHistory/newReport');
const OperationsHistoryIndexRouteWrapper = () => import(/* webpackChunkName: "operationsHistory" */ '@/app/generalPanel/reports/operationsHistory/indexRouteWrapper');
const NewAlarmsAndWarningsReport = () => import(/* webpackChunkName: "alarmsAndWarnings" */ '@/app/generalPanel/reports/alarmsAndWarnings/newReport');
const AlarmsAndWarningsIndexRouteWrapper = () => import(/* webpackChunkName: "alarmsAndWarnings" */ '@/app/generalPanel/reports/alarmsAndWarnings/indexRouteWrapper');
const ProfileEditing = () => import(/* webpackChunkName: "generalPanelProfile" */ '../adminPanel/profile/editing');
const RegionalEditing = () => import(/* webpackChunkName: "generalPanelRegional" */ '../adminPanel/regional/editing');
const Reports = () => import(/* webpackChunkName: "reports" */ '../reports/Reports');
const ReportsIndex = () => import(/* webpackChunkName: "generalPanelReports" */ '../reports');
const SoftwareLicense = () => import(/* webpackChunkName: "generalPanelSoftwareLicense" */ '../softwareLicense');
const ReleaseNotes = () => import(/* webpackChunkName: "generalPanelReleaseNotes" */ '../releaseNotes');
const Versions = () => import(/* webpackChunkName: "generalPanelVersions" */ '../versions');
const UserEditing = () => import(/* webpackChunkName: "generalPanelUser" */ '../adminPanel/user/editing');
const AssetList = () => import(/* webpackChunkName: "generalPanelAssetList" */ '../assetList');

export default {
  path: '',
  component: GeneralPanel,
  meta: {
    breadcrumb: {
      name: 'page-name.home',
      routeName: 'home',
    },
  },
  children: [
    {
      path: '',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        breadcrumb: {
          name: 'page-name.dashboard',
          noNavigation: true,
          noTitle: true,
        },
      },
    },
    {
      path: 'lista-de-ativos',
      name: 'monitoring',
      component: AssetList,
      meta: {
        breadcrumb: { name: 'page-name.asset-list', noNavigation: true },
      },
    },
    {
      path: 'alarmes-e-avisos',
      name: 'alarms-and-warnings',
      component: AlarmsAndWarnings,
      meta: {
        breadcrumb: {
          name: 'page-name.alarms-and-warnings',
          noNavigation: true,
          noTitle: true,
        },
        permissions: ['PER028'],
      },
    },
    {
      path: 'status-da-rede',
      name: 'network-status',
      component: NetworkStatus,
      meta: {
        breadcrumb: {
          name: 'page-name.network-status',
          noNavigation: true,
          noTitle: true,
        },
        permissions: ['PER010'],
      },
    },
    {
      path: 'gerenciamento-de-rede',
      name: 'network-management',
      component: NetworkManagement,
      meta: {
        breadcrumb: {
          name: 'page-name.network-management',
          noNavigation: true,
          noTitle: true,
        },
        permissions: ['PER010'],
      },
    },
    {
      path: 'gerenciamento-de-rede/nova/',
      component: NetworkEditing,
      name: 'new-network',
      meta: {
        breadcrumb: {
          reset: true,
          items: [
            {
              name: 'page-name.new-network',
            },
          ],
        },
        permissions: ['PER010'],
      },
    },
    {
      path: 'gerenciamento-de-rede/instalacao/:instalacaoId',
      name: 'network-management-installation',
      component: InstallationNetworks,
      meta: {
        breadcrumb: {
          name: 'page-name.network-management-installation',
          noNavigation: true,
          noTitle: true,
        },
        permissions: ['PER010'],
      },
    },
    {
      path: 'processamento',
      name: 'analysis-processing',
      component: AnalysisProcessing,
      meta: {
        breadcrumb: {
          name: 'page-name.analysis-processing',
          noNavigation: true,
        },
        permissions: ['PER017'],
      },
    },
    {
      path: 'painel-do-administrador',
      component: AdminPanelIndex,
      meta: {
        breadcrumb: {
          name: 'page-name.admin-panel',
          routeName: 'admin-panel',
          noNavigation: true,
        },
      },
      children: [
        {
          path: '',
          name: 'admin-panel',
          component: AdminPanel,
          props: route => ({
            activeTabName: route.query.activeTabName || route.params.activeTabName || 'users',
          }),
          meta: {
            breadcrumb: {
              name: 'page-name.admin-panel',
              noNavigation: true,
            },
          },
        },
        {
          path: 'perfil/novo',
          component: ProfileEditing,
          name: 'profile.new',
          meta: {
            breadcrumb: {
              reset: true,
              items: [
                {
                  name: 'page-name.home',
                  routeName: 'dashboard',
                },
                {
                  name: 'page-name.admin-panel',
                  routeName: 'admin-panel',
                  params: {
                    activeTabName: 'profiles',
                  },
                },
                {
                  name: 'page-name.new-profile',
                },
              ],
            },
            permissions: ['PER002'],
          },
        },
        {
          path: 'perfil/editar/:profileId',
          component: ProfileEditing,
          name: 'profile.edit',
          props: route => ({
            profileIdForEdit: route.params.userId,
          }),
          meta: {
            breadcrumb: {
              reset: true,
              items: [
                {
                  name: 'page-name.home',
                  routeName: 'dashboard',
                },
                {
                  name: 'page-name.admin-panel',
                  routeName: 'admin-panel',
                  params: {
                    activeTabName: 'profiles',
                  },
                },
                {
                  name: 'page-name.edit-profile',
                },
              ],
            },
            permissions: ['PER002'],
          },
        },
        {
          path: 'usuario/novo',
          component: UserEditing,
          name: 'user.new',
          meta: {
            breadcrumb: {
              reset: true,
              items: [
                {
                  name: 'page-name.home',
                  routeName: 'dashboard',
                },
                {
                  name: 'page-name.admin-panel',
                  routeName: 'admin-panel',
                  params: {
                    activeTabName: 'users',
                  },
                },
                {
                  name: 'page-name.new-user',
                },
              ],
            },
            permissions: ['PER011'],
          },
        },
        {
          path: 'usuario/editar/:userId',
          component: UserEditing,
          name: 'user.edit',
          props: route => ({
            userIdForEdit: route.params.userId,
          }),
          meta: {
            breadcrumb: {
              reset: true,
              items: [
                {
                  name: 'page-name.home',
                  routeName: 'dashboard',
                },
                {
                  name: 'page-name.admin-panel',
                  routeName: 'admin-panel',
                  params: {
                    activeTabName: 'users',
                  },
                },
                {
                  name: 'page-name.edit-user',
                },
              ],
            },
            permissions: ['PER011'],
          },
        },
        {
          path: 'regional/nova',
          component: RegionalEditing,
          name: 'regional.new',
          meta: {
            breadcrumb: {
              reset: true,
              items: [
                {
                  name: 'page-name.home',
                  routeName: 'dashboard',
                },
                {
                  name: 'page-name.admin-panel',
                  routeName: 'admin-panel',
                  params: {
                    activeTabName: 'regional',
                  },
                },
                {
                  name: 'page-name.new-regional',
                },
              ],
            },
            permissions: ['PER009'],
          },
        },
        {
          path: 'regional/editar/:regionalId',
          component: RegionalEditing,
          name: 'regional.edit',
          meta: {
            breadcrumb: {
              reset: true,
              items: [
                {
                  name: 'page-name.home',
                  routeName: 'dashboard',
                },
                {
                  name: 'page-name.admin-panel',
                  routeName: 'admin-panel',
                  params: {
                    activeTabName: 'regional',
                  },
                },
                {
                  name: 'page-name.edit-regional',
                },
              ],
            },
            permissions: ['PER009'],
          },
        },
        {
          path: 'instalacao/editar/:installationId',
          component: InstallationEditing,
          name: 'installation.edit',
          meta: {
            translatePageName: false,
            pageName: '',
            breadcrumb: {
              reset: true,
              items: [
                {
                  name: 'page-name.home',
                  routeName: 'dashboard',
                },
                {
                  name: 'page-name.admin-panel',
                  routeName: 'admin-panel',
                  params: {
                    activeTabName: 'installations',
                  },
                },
                {
                  name: 'page-name.electrical-installation',
                },
              ],
            },
            permissions: ['PER020'],
          },
        },
      ],
    },
    {
      path: 'relatorios',
      name: 'reports.index',
      component: ReportsIndex,
      redirect: {
        name: 'reports',
      },
      meta: {
        breadcrumb: {
          name: 'page-name.reports',
          noNavigation: true,
        },
      },
      children: [
        {
          path: '',
          component: Reports,
          name: 'reports',
          props: route => ({
            activeTabName: route.query.activeTabName ?? null,
          }),
        },
        {
          path: 'historico-dados',
          name: 'reports.data-history',
          component: DataHistoryIndexRouteWrapper,
          redirect: {
            name: 'reports',
            params: {
              activeTabName: 'data-history',
            },
          },
          meta: {
            breadcrumb: {
              name: 'reports.data-history.title',
              noNavigation: true,
            },
          },
          children: [
            {
              path: 'new-report',
              component: NewDataHistoryReport,
              name: 'reports.data-history.new-report',
              meta: {
                breadcrumb: {
                  reset: true,
                  items: [
                    {
                      name: 'page-name.home',
                      routeName: 'dashboard',
                    },
                    {
                      name: 'page-name.reports',
                      routeName: 'reports.index',
                    },
                    {
                      name: 'reports.data-history.title',
                      routeName: 'reports.data-history',
                      params: {
                        activeTabName: 'data-history',
                      },
                    },
                    {
                      name: 'page-name.new-report',
                    },
                  ],
                },
              },
            },
            {
              path: 'edit-report/:id',
              component: NewDataHistoryReport,
              name: 'reports.data-history.edit-report',
              meta: {
                breadcrumb: {
                  reset: true,
                  items: [
                    {
                      name: 'page-name.home',
                      routeName: 'dashboard',
                    },
                    {
                      name: 'page-name.reports',
                      routeName: 'reports.index',
                    },
                    {
                      name: 'reports.data-history.title',
                      routeName: 'reports.data-history',
                      params: {
                        activeTabName: 'data-history',
                      },
                    },
                    {
                      name: 'page-name.edit-report',
                    },
                  ],
                },
              },
            },
          ],
        },
        {
          path: 'oscilografia',
          name: 'reports.oscillography',
          component: OscillographyIndexRouteWrapper,
          redirect: {
            name: 'reports',
            params: {
              activeTabName: 'oscillography',
            },
          },
          meta: {
            breadcrumb: {
              name: 'reports.oscillography.oscillography',
              noNavigation: true,
            },
          },
          children: [
            {
              path: 'novo',
              component: NewOscillographyReport,
              name: 'reports.oscillography.new-report',
              meta: {
                breadcrumb: {
                  reset: true,
                  items: [
                    {
                      name: 'page-name.home',
                      routeName: 'dashboard',
                    },
                    {
                      name: 'page-name.reports',
                      routeName: 'reports.index',
                    },
                    {
                      name: 'reports.oscillography.oscillography',
                      routeName: 'reports.oscillography',
                      params: {
                        activeTabName: 'oscillography',
                      },
                    },
                    {
                      name: 'page-name.new-report',
                    },
                  ],
                },
              },
            },
            {
              path: 'editar/:relatorioId',
              component: NewOscillographyReport,
              name: 'reports.oscillography.edit-report',
              meta: {
                breadcrumb: {
                  reset: true,
                  items: [
                    {
                      name: 'page-name.home',
                      routeName: 'dashboard',
                    },
                    {
                      name: 'page-name.reports',
                      routeName: 'reports.index',
                    },
                    {
                      name: 'reports.oscillography.oscillography',
                      routeName: 'reports.oscillography',
                      params: {
                        activeTabName: 'oscillography',
                      },
                    },
                    {
                      name: 'page-name.edit-report',
                    },
                  ],
                },
              },
            },
          ],
        },
        {
          path: 'alarmes-e-avisos',
          name: 'reports.alarms-and-warnings',
          component: AlarmsAndWarningsIndexRouteWrapper,
          redirect: {
            name: 'reports',
            params: {
              activeTabName: 'alarms-and-warnings',
            },
          },
          meta: {
            breadcrumb: {
              name: 'reports.alarms-and-warnings.alarms-and-warnings',
              noNavigation: true,
            },
          },
          children: [
            {
              path: 'novo',
              name: 'reports.alarms-and-warnings.new-report',
              component: NewAlarmsAndWarningsReport,
              meta: {
                breadcrumb: {
                  reset: true,
                  items: [
                    {
                      name: 'page-name.home',
                      routeName: 'dashboard',
                    },
                    {
                      name: 'page-name.reports',
                      routeName: 'reports.index',
                    },
                    {
                      name: 'reports.alarms-and-warnings.alarms-and-warnings',
                      routeName: 'reports.alarms-and-warnings',
                      params: {
                        activeTabName: 'alarms-and-warnings',
                      },
                    },
                    {
                      name: 'page-name.new-report',
                    },
                  ],
                },
              },
            },
            {
              path: 'editar/:relatorioId',
              component: NewAlarmsAndWarningsReport,
              name: 'reports.alarms-and-warnings.edit-report',
              meta: {
                breadcrumb: {
                  reset: true,
                  items: [
                    {
                      name: 'page-name.home',
                      routeName: 'dashboard',
                    },
                    {
                      name: 'page-name.reports',
                      routeName: 'reports.index',
                    },
                    {
                      name: 'reports.alarms-and-warnings.alarms-and-warnings',
                      routeName: 'reports.alarms-and-warnings',
                      params: {
                        activeTabName: 'alarms-and-warnings',
                      },
                    },
                    {
                      name: 'page-name.edit-report',
                    },
                  ],
                },
              },
            },
          ],
        },
        {
          path: 'historico-operacoes',
          name: 'reports.operations-history',
          component: OperationsHistoryIndexRouteWrapper,
          redirect: {
            name: 'reports',
            params: {
              activeTabName: 'operations-history',
            },
          },
          meta: {
            breadcrumb: {
              name: 'reports.operations-history',
              noNavigation: true,
            },
          },
          children: [
            {
              path: 'novo',
              component: NewOperationsHistoryReport,
              name: 'reports.operations-history.new-report',
              meta: {
                breadcrumb: {
                  reset: true,
                  items: [
                    {
                      name: 'page-name.home',
                      routeName: 'dashboard',
                    },
                    {
                      name: 'page-name.reports',
                      routeName: 'reports.index',
                    },
                    {
                      name: 'reports.operations-history.title',
                      routeName: 'reports.operations-history',
                      params: {
                        activeTabName: 'operations-history',
                      },
                    },
                    {
                      name: 'page-name.new-report',
                    },
                  ],
                },
              },
            },
            {
              path: 'editar/:relatorioId',
              component: NewOperationsHistoryReport,
              name: 'reports.operations-history.edit-report',
              meta: {
                breadcrumb: {
                  reset: true,
                  items: [
                    {
                      name: 'page-name.home',
                      routeName: 'dashboard',
                    },
                    {
                      name: 'page-name.reports',
                      routeName: 'reports.index',
                    },
                    {
                      name: 'reports.operations-history.title',
                      routeName: 'reports.operations-history',
                      params: {
                        activeTabName: 'operations-history',
                      },
                    },
                    {
                      name: 'page-name.edit-report',
                    },
                  ],
                },
              },
            },
          ],
        },
      ],
    },
    {
      path: 'licenca-software',
      name: 'my-account.software-license-review',
      component: SoftwareLicense,
      meta: {
        breadcrumb: { name: 'page-name.software-license', noNavigation: true },
      },
    },
    {
      path: 'help/releaseNotes',
      name: 'help.releaseNotes',
      component: ReleaseNotes,
      meta: { breadcrumb: { name: 'page-name.releaseNotes', noNavigation: true } },
    },
    {
      path: 'help/versoes',
      name: 'help.versions',
      component: Versions,
      meta: { breadcrumb: { name: 'page-name.versions', noNavigation: true } },
    },
  ],
};
